import { OrderItem, CustomerOrder } from "../models/Order.model";

export function calculateOrderTotals(
  orderItems: OrderItem[],
  customerOrders: CustomerOrder[]
) {
  const freightItem = orderItems.find((data) => data.transportPrice);
  const freightCost = Number(freightItem?.transportPrice) || 0;

  const discountPrice =
    Number(customerOrders[0]?.discountPrice) ||
    Number(orderItems[0]?.discountPrice) ||
    0;

  const subTotal = customerOrders.reduce((sum, item, idx) => {
    const qty = orderItems[idx]?.quantity || 1;
    return sum + qty * item.price;
  }, 0);

  const taxableSubTotal = Math.max(subTotal - discountPrice, 0);

  const discountRatio = subTotal > 0 ? taxableSubTotal / subTotal : 0;

  const gstMap = customerOrders.reduce(
    (map: Map<number, { taxable: number; tax: number }>, item, idx) => {
      const qty = orderItems[idx]?.quantity || 1;
      const originalLineAmount = qty * item.price;

      const taxableLineAmount = originalLineAmount * discountRatio;

      const rate = item.gst;
      const tax = (taxableLineAmount * rate) / 100;

      if (!map.has(rate)) {
        map.set(rate, { taxable: 0, tax: 0 });
      }

      const entry = map.get(rate)!;
      entry.taxable += taxableLineAmount;
      entry.tax += tax;
      return map;
    },
    new Map()
  );

  const totalTax = Array.from(gstMap.values()).reduce((s, e) => s + e.tax, 0);

  const grandTotal = taxableSubTotal + totalTax + freightCost;

  return {
    subTotal,
    gstMap,
    totalTax,
    freight: { transportPrice: freightCost },
    grandTotal,
    discountPrice,
  };
}
